export default "__VITE_ASSET__DyK6NSFa__"